export const selectSessionData = ({ session: { data } }) => ({ ...data });
export const sessionHydrated = ({ session: { _persist } }) =>
  _persist.rehydrated;
